import React, { useState } from 'react';
import { useLang } from '../../core/lang';
import LangKeys from '../../core/locales/keys';
import { 
  ArrowLeft, 
  Check, 
  Layers, 
  Layout, 
  Smartphone,
  ChevronRight
} from 'lucide-react';

const SampleInvoicesView = ({ onBack, onSelect, tabIndex }) => {
  const { t } = useLang();
  
  const templates = [
    { id: 'premium', name: t(LangKeys.premium_invoice), img: '/premium_invoice.png' },
    { id: 'thermal', name: t(LangKeys.thermal_invoice), img: '/thermal_invoice.png' },
    { id: 'basic', name: t(LangKeys.basic_invoice), img: '/basic_invoice.png' },
  ];

  const [selectedIndex, setSelectedIndex] = useState(0);

  return (
    <div style={styles.container}>
      <div style={styles.header}>
        <div style={styles.headerLeft}>
          <button onClick={onBack} style={styles.backBtn}><ArrowLeft size={20} /></button>
          <h3 style={styles.title}>{templates[selectedIndex].name}</h3>
        </div>
      </div>

      <div style={styles.previewArea}>
         <img 
           src={templates[selectedIndex].img} 
           alt={templates[selectedIndex].name} 
           style={styles.mainImg}
         />
      </div>

      <div style={styles.selectorArea}>
         <div style={styles.thumbsRow}>
            {templates.map((tpl, i) => (
              <div 
                key={tpl.id} 
                style={{...styles.thumbWrapper, ...(selectedIndex === i ? styles.thumbActive : {})}}
                onClick={() => setSelectedIndex(i)}
              >
                 <div style={{...styles.thumbImgBox, ...(selectedIndex === i ? {borderColor: '#1D4ED8', transform: 'translateY(-5px)'} : {})}}>
                    <img src={tpl.img} alt={tpl.name} style={styles.thumbImg} />
                 </div>
                 <span style={{...styles.thumbName, ...(selectedIndex === i ? {color: 'white'} : {})}}>{tpl.name}</span>
              </div>
            ))}
         </div>

         <div style={styles.footer}>
            <button style={styles.useBtn} onClick={() => onSelect(templates[selectedIndex])}>
               <Check size={20} />
               <span>{t(LangKeys.use_this_template).toUpperCase()}</span>
            </button>
         </div>
      </div>
    </div>
  );
};

const styles = {
  container: { display: 'flex', flexDirection: 'column', height: '100%', background: '#0F172A' },
  header: { padding: '16px 24px', background: 'transparent', color: 'white', display: 'flex', alignItems: 'center' },
  headerLeft: { display: 'flex', alignItems: 'center', gap: '12px' },
  backBtn: { width: '32px', height: '32px', borderRadius: '10px', border: 'none', background: 'rgba(255,255,255,0.1)', color: 'white', display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer' },
  title: { fontSize: '16px', fontWeight: '800', margin: 0 },
  previewArea: { flex: 1, padding: '20px', display: 'flex', alignItems: 'center', justifyContent: 'center', overflow: 'hidden', background: 'radial-gradient(circle, rgba(30,41,59,1) 0%, rgba(15,23,42,1) 100%)' },
  mainImg: { maxWidth: '30%', maxHeight: '30%', objectFit: 'contain', borderRadius: '4px', boxShadow: '0 30px 60px -12px rgba(0,0,0,0.5), 0 18px 36px -18px rgba(0,0,0,0.5)' },
  selectorArea: { padding: '20px 16px', background: 'rgba(0,0,0,0.3)', borderTop: '1px solid rgba(255,255,255,0.05)', backdropFilter: 'blur(10px)' },
  thumbsRow: { display: 'flex', justifyContent: 'center', gap: '16px', marginBottom: '20px' },
  thumbWrapper: { display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '8px', cursor: 'pointer', transition: '0.3s' },
  thumbImgBox: { width: '90px', height: '120px', borderRadius: '10px', background: 'white', padding: '4px', border: '2px solid transparent', overflow: 'hidden', transition: '0.3s', boxShadow: '0 8px 12px -3px rgba(0,0,0,0.1)' },
  thumbActive: { },
  thumbImg: { width: '100%', height: '100%', objectFit: 'cover', borderRadius: '6px' },
  thumbName: { fontSize: '11px', fontWeight: '700', color: '#64748B', transition: '0.3s' },
  footer: { padding: '0 10px' },
  useBtn: { width: '100%', height: '48px', borderRadius: '14px', border: 'none', background: '#1D4ED8', color: 'white', fontWeight: '800', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px', cursor: 'pointer', boxShadow: '0 8px 20px -5px rgba(29, 78, 216, 0.4)' }
};

export default SampleInvoicesView;
